// Duplicate of servers/user-service/src/server/sanitizeEmail.js
export function sanitizeEmail(emailString: string) {
  let sanitizedEmail = emailString.toLowerCase();

  const domain = sanitizedEmail.split('@')[1];
  if (domain === 'gmail.com' || domain === 'paragontruss.com') {
    const dotList = sanitizedEmail.split('.');
    const extension = dotList.pop();

    sanitizedEmail = `${dotList.join('')}.${extension}`;
  }

  return sanitizedEmail;
}
